import { useMutation } from "@tanstack/react-query";
import { getChatApiClient } from "@shared/apis/sidekick/api-factories";

type UseEditThreadTitleProps = {
  onSuccess?: () => void;
};

export const useEditThreadTitle = (props?: UseEditThreadTitleProps) => {
  const { onSuccess } = props || {};
  const chatApi = getChatApiClient();
  const mutation = useMutation({
    mutationFn: async (params: { threadId: string; title: string }) => {
      const response = await chatApi.chatControllerRenameThread({
        thread: params.threadId,
        renameThreadRequest: {
          title: params.title,
        },
      });
      onSuccess?.();
      return response;
    },
    onError: (error, { threadId }) => {
      console.error(`Failed to edit thread name. ID: ${threadId}`, error);
    },
  });

  return mutation;
};
